// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lists-manage-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.lists-manage-header {
  padding: 16px 16px 12px;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lists-manage-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--accent-primary);
}

.create-list-page-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.header-create-btn {
  background: var(--accent-primary);
  color: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  box-shadow: 0 2px 8px var(--shadow-color);
}

.header-create-btn:hover {
  background: var(--accent-hover);
  box-shadow: 0 4px 12px var(--shadow-strong);
  transform: translateY(-1px);
}

.lists-manage-bottom-actions {
  display: flex;
  justify-content: center;
  margin-top: 32px;
  padding: 16px;
}

.bottom-create-btn {
  background: transparent;
  color: var(--accent-primary);
  padding: 12px 28px;
  font-size: 15px;
  border: 2px dashed var(--accent-primary);
}

.bottom-create-btn:hover {
  background: var(--hover-background, rgba(29, 161, 242, 0.1));
  color: var(--accent-hover);
  border-color: var(--accent-hover);
  transform: translateY(-1px);
}

.lists-manage-empty {
  padding: 24px 16px;
  color: var(--text-secondary);
  font-size: 14px;
}

.lists-manage-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.lists-manage-item {
  border-bottom: 1px solid var(--border-color);
}

.lists-manage-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px 4px 16px;
}

.lists-manage-info {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  min-width: 0;
}

.lists-manage-name {
  flex: 1 1;
  font-size: 15px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lists-manage-count {
  font-size: 12px;
  color: var(--text-secondary);
  flex-shrink: 0;
}

.lists-manage-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.lists-action-btn {
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  border: 1px solid var(--border-color);
}

.lists-view-btn {
  color: var(--text-primary);
  background: none;
}

.lists-view-btn:hover {
  background: var(--hover-bg);
}

.lists-delete-btn {
  color: var(--error-color, #e05252);
  background: none;
  border-color: transparent;
}

.lists-delete-btn:hover {
  border-color: var(--error-color, #e05252);
}

.lists-delete-btn:disabled, .lists-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Members section */
.lists-members {
  background: var(--bg-secondary, var(--card-bg));
  border-top: 1px solid var(--border-color);
  padding: 4px 0;
}

.lists-members-empty {
  padding: 12px 20px;
  color: var(--text-secondary);
  font-size: 13px;
  margin: 0;
}

.lists-members-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.lists-member-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px 8px 20px;
}

.lists-member-link {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  text-decoration: none;
  min-width: 0;
}

.lists-member-link:hover .lists-member-name {
  text-decoration: underline;
}

.lists-member-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.lists-member-name {
  font-size: 14px;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lists-member-remove {
  background: none;
  border: none;
  font-size: 18px;
  line-height: 1;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  flex-shrink: 0;
}

.lists-member-remove:hover {
  color: var(--error-color, #e05252);
  background: rgba(224, 82, 82, 0.1);
}

.lists-member-remove:disabled {
  opacity: 0.5;
  cursor: wait;
}.lists-manage-rename-input {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 4px 8px;
  width: 100%;
  max-width: 300px;
  margin-right: 12px;
}
.lists-manage-rename-input:focus {
  outline: none;
  border-color: var(--accent-primary);
}
`, "",{"version":3,"sources":["webpack://./src/pages/ListsManage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,+CAA+C;EAC/C,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd,CAAC;EACC,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mCAAmC;AACrC","sourcesContent":[".lists-manage-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n}\r\n\r\n.lists-manage-header {\r\n  padding: 16px 16px 12px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.lists-manage-title {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.create-list-page-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border-radius: 24px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  border: none;\r\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.header-create-btn {\r\n  background: var(--accent-primary);\r\n  color: #ffffff;\r\n  padding: 8px 16px;\r\n  font-size: 14px;\r\n  box-shadow: 0 2px 8px var(--shadow-color);\r\n}\r\n\r\n.header-create-btn:hover {\r\n  background: var(--accent-hover);\r\n  box-shadow: 0 4px 12px var(--shadow-strong);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.lists-manage-bottom-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 32px;\r\n  padding: 16px;\r\n}\r\n\r\n.bottom-create-btn {\r\n  background: transparent;\r\n  color: var(--accent-primary);\r\n  padding: 12px 28px;\r\n  font-size: 15px;\r\n  border: 2px dashed var(--accent-primary);\r\n}\r\n\r\n.bottom-create-btn:hover {\r\n  background: var(--hover-background, rgba(29, 161, 242, 0.1));\r\n  color: var(--accent-hover);\r\n  border-color: var(--accent-hover);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.lists-manage-empty {\r\n  padding: 24px 16px;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n}\r\n\r\n.lists-manage-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.lists-manage-item {\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.lists-manage-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 12px 4px 16px;\r\n}\r\n\r\n.lists-manage-info {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 12px 0;\r\n  min-width: 0;\r\n}\r\n\r\n.lists-manage-name {\r\n  flex: 1;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.lists-manage-count {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.lists-manage-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.lists-action-btn {\r\n  padding: 5px 10px;\r\n  border-radius: 6px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  text-decoration: none;\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.lists-view-btn {\r\n  color: var(--text-primary);\r\n  background: none;\r\n}\r\n\r\n.lists-view-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.lists-delete-btn {\r\n  color: var(--error-color, #e05252);\r\n  background: none;\r\n  border-color: transparent;\r\n}\r\n\r\n.lists-delete-btn:hover {\r\n  border-color: var(--error-color, #e05252);\r\n}\r\n\r\n.lists-delete-btn:disabled, .lists-action-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Members section */\r\n.lists-members {\r\n  background: var(--bg-secondary, var(--card-bg));\r\n  border-top: 1px solid var(--border-color);\r\n  padding: 4px 0;\r\n}\r\n\r\n.lists-members-empty {\r\n  padding: 12px 20px;\r\n  color: var(--text-secondary);\r\n  font-size: 13px;\r\n  margin: 0;\r\n}\r\n\r\n.lists-members-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.lists-member-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 8px 16px 8px 20px;\r\n}\r\n\r\n.lists-member-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex: 1;\r\n  text-decoration: none;\r\n  min-width: 0;\r\n}\r\n\r\n.lists-member-link:hover .lists-member-name {\r\n  text-decoration: underline;\r\n}\r\n\r\n.lists-member-avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.lists-member-name {\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.lists-member-remove {\r\n  background: none;\r\n  border: none;\r\n  font-size: 18px;\r\n  line-height: 1;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  padding: 4px 6px;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.lists-member-remove:hover {\r\n  color: var(--error-color, #e05252);\r\n  background: rgba(224, 82, 82, 0.1);\r\n}\r\n\r\n.lists-member-remove:disabled {\r\n  opacity: 0.5;\r\n  cursor: wait;\r\n}.lists-manage-rename-input {\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 4px;\r\n  padding: 4px 8px;\r\n  width: 100%;\r\n  max-width: 300px;\r\n  margin-right: 12px;\r\n}\r\n.lists-manage-rename-input:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
